export default __webpack_public_path__ + "static/media/05-MontrealCanadiens-Logo.1f314c18.jpg";